export default __webpack_public_path__ + "static/media/2420_2424 stand.94e04905.jpg";